import PropTypes from 'prop-types'
import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import useZohoClientDataImporter from './useZohoClientDataImporter'

const ZohoClientDataImporter = ({ fetchZohoClient, disabled, isImporting, hidden }) => {
  const { t, buttonKind, handleClick } = useZohoClientDataImporter(fetchZohoClient)

  if (hidden) {
    return null
  }

  return (
    <SDFormControl plainLabel>
      <SDButton
        style={{ marginTop: '0.5rem' }}
        disabled={disabled || isImporting}
        isLoading={isImporting}
        block={true}
        kind={buttonKind}
        onClick={handleClick}
      >
        {t('subscriptionForm:customer_module.zoho_client_fetcher.label')}
      </SDButton>
    </SDFormControl>
  )
}

ZohoClientDataImporter.propTypes = {
  fetchZohoClient: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  isImporting: PropTypes.bool,
  hidden: PropTypes.bool,
}

export default ZohoClientDataImporter
